import { fetchPress, postRequest, fetchTestimonials } from "../../actions/api";
import { findAndRemove, getAgentIds, updateOfficeSelect } from "../shared/util";
import Footer from "../shared/footer/footer";
import {
  initGoogleAnalytics,
  initGoogleTagManager,
  initInHouseGA,
} from "../shared/head/analytics";
import Head from "../shared/head/";
import HeaderTop from "../shared/header-top/header-top";
import StickyContact from "../shared/sticky-contact/sticky-contact";
import { logPageView } from "../shared/analytics";
import NavBar from "../shared/navbar/navbar";
import objectFitImages from "object-fit-images";
import request from "superagent";
import React, { Component } from "react";
import Subscribe from "../shared/footer/subscribe";
import Print from "../listing-detail/print-wrapper";

import { ARCTIC, USER_MANAGER, NAVY } from "../../constants/constants";

import "./app.scss";
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agentId: props.location.query.agentid,
      teamId: props.location.query.teamid,
      // fromPreview for handling request coming from CMS preview screen
      fromPreview: props.location.query.fromPreview,
      noGlobalPropertyResults: false,
      // do nav items analysis later which coming, which not coming and on what condition they coming
      navItems: [
        { label: "My Listings", link: "/listings/sales" },
        { label: "Global Listings", link: "/global-listings/sales" },
        { label: "Select Solds", link: "/solds/sales" },
        { label: "Market Update", link: "/market-update" },
        { label: "About", link: "/about" },
        { label: "Our Advantage", link: "/our-advantage" },
        { label: "Press", link: "/press" },
        { label: "Contact", link: "/contact" },
      ],
    };
    this.mainRef = React.createRef();
  }

  removeNavLink = (link) => {
    const navItems = findAndRemove(this.state.navItems, "link", link);
    this.setState({ navItems: navItems });
  };

  componentDidMount() {
    objectFitImages(); //object size polyfill
    if (this.props.entity) {
      this.initialize(this.props.entity);
    } else {
      this.props.actions
        .loadConfig() // check its purpose and update accordingly
        .then(() =>
          this.props.actions.mapEntityId(
            this.state.agentId,
            this.state.teamId,
            this.state.fromPreview
          )
        )
        .then(() => {
          this.initialize(this.props.entity);
        })
        .catch((e) => {
          console.error("error in getting agent data", e);
        });
    }
  }

  initialize = (entity) => {
    this.redirect(entity); //check how happening
    initInHouseGA(entity.siteOptions.analytics);
    initGoogleAnalytics(entity.siteOptions.analytics);
    logPageView(this.props.location);
    initGoogleTagManager(entity.siteOptions.analytics);
    this.updateSearchPageLink();

    if (
      !entity.siteOptions.globalSettings ||
      entity.siteOptions.globalSettings.showGlobalPage === false
    ) {
      this.updateNavLinks(false);
    } else {
      this.globalListings()
        .then((hasCount) => {
          this.updateNavLinks(hasCount);
        })
        .catch((err) => {
          console.log(
            "error fetching GP counts - disabling Global Listings Link - ",
            err
          );
          this.updateNavLinks(false);
        });
    }

    this.getPressForHomePage(entity);
    this.getHomePageFeaturedListings(entity);
    this.selectSoldsCountCheck(entity);
    this.getTestimonialsForHomePage(entity);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      logPageView(nextProps.location);
      window.scrollTo(0, 0);
    }
  }

  redirect = (entity) => {
    if (entity.redirect && !this.state.teamId && !this.state.agentId) {
      // can't do server side redirect from ajax request :(
      window.location.href = entity.redirect;
    }
  };

  updateSearchPageLink = () => {
    if (this.props.entity.siteOptions.showSearchPage) {
      const navItems = this.state.navItems;
      navItems.unshift({
        label: "Search Properties",
        link: `/${this.props.entity.region.urlPart}/sales`,
      });
      this.setState({ navItems: navItems });
    }
  };

  globalListings = async () => {
    const hasCount = await request
      .post(
        "/api/globalListings/findGlobalListings?listingType=sale&sortBy=price"
      )
      .set("Content-Type", "application/json")
      .send(this.props.entity.siteOptions.globalSettings)
      .then((res) => {
        if (res.body.salesCount === 0 && res.body.rentalsCount === 0) {
          return false;
        } else {
          return true;
        }
      });

    return hasCount;
  };

  updateNavLinks = (hasCount) => {
    const {
      customNavItem,
      customNavItem1,
      entityType,
      showMarketUpdatePage,
      showCustomNavItem,
      showCustomNavItem1,
      showOnlyWithUs,
      showSelectSoldsPage,
      showGlobalPage,
      defaultSelectionsManager,
    } = this.props.entity.siteOptions;
    const agentType = this.props.entity.agentType;
    let navItems = this.state.navItems.slice();
    if (showCustomNavItem) {
      navItems.splice(navItems.length - 1, 0, {
        label: customNavItem.title,
        link: customNavItem.url,
        external: true,
      });
    }
    if (showCustomNavItem1) {
      navItems.splice(navItems.length - 1, 0, {
        label: customNavItem1.title,
        link: customNavItem1.url,
        external: true,
      });
    }
    if (!showOnlyWithUs) {
      navItems = findAndRemove(navItems, "link", "/our-advantage");
    }
    if (!showSelectSoldsPage) {
      navItems = findAndRemove(navItems, "link", "/solds/sales");
    }
    if (!showMarketUpdatePage) {
      navItems = findAndRemove(navItems, "link", "/market-update");
    }

    if (!showGlobalPage || hasCount === false) {
      navItems = findAndRemove(navItems, "link", "/global-listings/sales");
    }

    if (entityType === 2) {
      const index = navItems.map((i) => i.link).indexOf("/listings/sales");
      navItems.splice(index, 1, {
        label: "Our Listings",
        link: "/listings/sales",
      });
    }
    if (showSelectSoldsPage && agentType === USER_MANAGER) {
      const index = navItems.map((i) => i.link).indexOf("/solds/sales");
      if (defaultSelectionsManager) {
        navItems.splice(index, 1, {
          label: "Office Select Sales",
          link: "/solds/sales",
        });
      } else {
        navItems.splice(index, 1);
      }
    }
    this.setState({ navItems: navItems });
  };

  getPressForHomePage = (entity) => {
    const filter = {
      agentIds: getAgentIds(entity),
      activePage: 1,
      resultsPerPage: this.props.defaultOptions.maxPressItems,
    };
    fetchPress(filter)
      .then((press) => {
        if (press && press.results.length > 0)
          this.props.actions.savePress(press);
        else this.removeNavLink("/press");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  //we have implemented for agents only
  getTestimonialsForHomePage = (entity) => {
    const filter = {
      email: entity.brandEmail,
      dashIdentifier: entity.dashIdentifier,
      entityType: entity.entityType,
    };
    fetchTestimonials(filter)
      .then((response) => {
        if (response && response.length > 0) {
          const updatedResponse = response.filter((item) => {
            return item.Testimonial !== null && item.Testimonial !== "";
          });

          this.props.actions.saveTestimonials(
            updatedResponse.length > 0 ? updatedResponse : []
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  getHomePageFeaturedListings = (entity) => {
    let filterListinCount = {
      agentId: getAgentIds(entity),
      source: "sir",
    };
    postRequest("/api/listings/counts", filterListinCount)
      .then((results) => {
        if (results.salesCount <= 0 && results.rentalsCount <= 0) {
          this.removeNavLink("/listings/sales");
        }
        if (results && (results.salesCount > 0 || results.rentalsCount > 0)) {
          let filter = {
            agentId: getAgentIds(entity),
            sortField: "currentPrice",
            source: "sir",
          };
          if (results.salesCount > 2) {
            filter.listingType = "sale";
            filter.resultsPerPage = results.salesCount;
          }
          postRequest("/api/listings", filter)
            .then((results) => {
              if (results && results.resultCount > 0) {
                this.props.actions.saveHomePageFeaturedListings(
                  results.results
                );
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  selectSoldsCountCheck = (entity) => {
    const agentType = entity.agentType;
    let filter = {
      agentId: getAgentIds(entity),
      agentSelect: true,
    };
    // test below scenario
    if (agentType === USER_MANAGER) {
      filter = updateOfficeSelect(filter, agentType, entity);
    }
    postRequest("/api/solds/counts", filter)
      .then((results) => {
        if (
          !results ||
          (results.salesCount === 0 && results.rentalsCount === 0)
        ) {
          this.removeNavLink("/solds/sales");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  onSkipLinkClick = () => {
    this.mainRef.current.focus();
  };

  getThemeClass = (theme) => {
    switch (theme) {
      case ARCTIC:
        return "theme-light";
      case NAVY:
        return "theme-blue";
      default:
        return "theme-dark";
    }
  };

  render() {
    const component = this.props.routes[this.props.routes.length - 1];
    const pageClass = component ? component.name : "";
    const siteOptions = this.props.entity ? this.props.entity.siteOptions : {};
    const themeClass = this.getThemeClass(siteOptions.theme);
    const modalBackdrop = this.props.isModalOpen ? "body-modal-backdrop" : "";
    return this.props.entity ? (
      <div className={`${themeClass} ${pageClass} ${modalBackdrop}`}>
        <a onClick={this.onSkipLinkClick} href="#main" className="skip-link">
          Skip to main content
        </a>
        <Head entity={this.props.entity} location={this.props.location} />
        <div id="page-body">
          <header>
            <HeaderTop entity={this.props.entity} />
            <NavBar navItems={this.state.navItems} entity={this.props.entity} />
          </header>
          <main id="main" tabIndex="-1" ref={this.mainRef}>
            {this.props.children}
          </main>
          <footer>
            <Subscribe entity={this.props.entity} />
            <Footer
              navItems={this.state.navItems}
              entity={this.props.entity}
              listing={this.props.listing}
            />
            <StickyContact
              entity={this.props.entity}
              routes={this.props.routes}
              listing={this.props.listing}
            />
          </footer>
        </div>
        <Print listing={this.props.listing} entity={this.props.entity} />
      </div>
    ) : null;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/app/app.js